export const invoiceData={
    "Object": {
        "FiscSubseqDeliveryCode": null,
        "PaymentTerms": null,
        "SellerVatNum": null,
        "BuyerLegalForm": "LegalEntity",
        "BuyerTypeCode": "Domestic",
        "BuyerCountryCode": "PL",
        "BuyerTaxNum": "0001111",
        "BuyerIsVat": false,
        "BuyerVatNum": "1110000",
        "BuyerName": "Test buyer",
        "BuyerStreet": "Test buyer street",
        "BuyerPostCode": "1000",
        "BuyerCity": "Test buyer city",
        "BuyerRegNum": null,
        "BuyerId": null,
        "BuyerIsBudget": false,
        "BuyerBudgetNum": null,
        "DocNumber": null,
        "DocIssueDate": null,
        "DocDueDate": "2023-12-29",
        "DocTotalAmount": 122,
        "DocTotalVatAmountCC": 22,
        "DocStartDate": "2023-12-14",
        "DocEndDate": "2023-12-14",
        "DocDeliveryDate": null,
        "DocCurrencyCode": "EUR",
        "DocExchangeRate": 1,
        "DocAllowPercent": 0,
        "DocSigner": "fdsfsdf",
        "DocNote": null,
        "DocBuyerOrderRef": "123456789",
        "ParagonNumberFisc": null,
        "OriginalInvNumber": null,
        "OriginalInvIssueDate": null,
        "OriginalInvFiscUnitRegNum": null,
        "OriginalInvSerNumDevice": 0,
        "OriginalInvFiscDeviceRegNum": null,
        "DocPurposeCode": "OTHR",
        "DocTypeCode": "INVOICE",
        "DocSaleTypeCode": "Wholesale",
        "DocPaymentTypeCode": "NONCASH",
        "OperatorFISCRegistration": null,
        "PDFOriginal": null,
        "DeliveryAddress": null,
        "DeliveryCityName": null,
        "DeliveryCounCode": null,
        "DeliveryName": null,
        "DeliveryPostCode": null,
        "DeliveryRegNum": null,
        "DeliveryTaxNum": null,
        "CreditNoteType": null,
        "_details": {
            "Items": [{
                    "ItemName": "Test item 1",
                    "ItemQuantity": 1,
                    "ItemUmcCode": "piece",
                    "ItemNetPrice": 100,
                    "ItemRetailPriceInp": null,
                    "ItemAllowancePercent": 0,
                    "ItemVatCode": "22",
                    "ItemExciseAmount": 0
                }
            ],
            "Payments": [{
                    "PayCode": "CREDITTRANSFER",
                    "PayNumber": null,
                    "PayAmount": 0,
                    "PayPayeeAccountType": null,
                    "PayNetworkProvider": null,
                    "PayCardHolderOrReference": null,
                    "PayDocDate": null
                }
            ],
            "Attachments": [{
                    "AddDocDesc": null,
                    "AddDocRef": null,
                    "AttFileName": null,
                    "AttFileURI": null,
                    "AttMimeCode": null
                }
            ],
            "CreditNoteRefs": [{
                    "CNRefNumber": null,
                    "CNRefIssueDate": null,
                    "CNRefTotalAmount": 0
                }
            ]
        }
    },
    "Complexity": "Normal"
}
